import { Controller } from "stimulus"

export default class extends Controller
  @targets: ["form", "info"]
  
  verify: ->
    request = $.get @data.get('validateUrl'), $(@formTarget).serialize()
    request.done (response) =>
      @infoTarget.innerHTML = response